import { isEmbeddable } from '../constants/partners';
import { logDebug } from './remoteLogger';

export const MEDIA_PERMISSION_DENIED_EVENT = 'media_permission_denied_event';

/**
 * Tells the page or app hosting an embeddable partner what happened, in the same
 * `{ type, payload }` shape as the window events built by kry-view-layer.
 */
export const postWindowEvent = (
  type: string,
  payload: Record<string, unknown> = {}
) => {
  if (!isEmbeddable()) return;

  logDebug('postWindowEvent', `Will post ${type} to the host`);
  window.parent.postMessage({ type, payload }, '*');
};
